<template>
  <div class="table-container-common" :class="customClassContainer">
    <div class="table-title-account" :class="customTitle">{{ title }}</div>
    <div v-if="!isMobile() || isPosDevice">
      <b-table
          id="id-table"
          hover
          :items="items"
          :fields="fields"
          :footFields="footFields"
          :current-page="currentPage"
          responsive="sm"
      >
        <template #cell(matchHowToPlay)="value">
          <ul
              class="item-match"
              v-for="index in value.item.matchHowToPlay"
              :key="index"
          >
            <li class="item-match-custom">{{ index }}</li>
          </ul>
          <div
              v-if="value.item.matchHowToPlay !== 1"
              class="item-match-des"
          >
            Match {{ value.item.matchHowToPlay }} numbers
          </div>
          <div
              v-if="value.item.matchHowToPlay === 1"
              class="item-match-des"
          >
            Match {{ value.item.matchHowToPlay }} numbers and the bonus number
          </div>
        </template>
        <template #cell(mainNumbers)="data">
        <span v-for="(numbers, index) in data.value"
              :key="index"
        >
          <p>
            <span v-for="(n, idx) in numbers" :key="idx" class="ball">{{n}}</span>
          </p>
        </span>
        </template>
        <template #cell(action)="value">

          <button v-for="(action, index) in value.field.actions" :key="index"
                  @click="handleActions(action.action, action.value, value.item)"
                  type="button"
                  class="btn btn-outline-success">{{action.title}}</button>
        </template>
        <template v-if="customFoot" v-slot:custom-foot>

          <b-tr v-for="(f, idx) in footFields" :key="idx">
            <b-td colspan="4" variant="secondary" class="text-right">
              <b>{{ f.label }}</b>
            </b-td>
            <b-td colspan="1" variant="secondary" class="text-center">
              {{f.value}}
            </b-td>
          </b-tr>
        </template>
      </b-table>
    </div>
    <div v-if="isMobile() && !isPosDevice">
      <div class="table-mobile">
        <b-container v-if="title === 'Transaction(s) Overview'" class="table-mobile__items">
          <div
              v-for="(item, index) in items"
              :key="index"
              class="table-mobile__content"
          >
            <b-row class="table-mobile__item">
              <b-col cols="6" class="table-mobile__item-label">QR Code ID</b-col>
              <b-col cols="6" class="table-mobile__item-value">{{ item.code }}</b-col>
            </b-row>
            <hr>
            <b-row class="table-mobile__item table-mobile__2-items">
              <b-col cols="6" class="table-mobile__item-left">
                <div class="table-mobile__item-label">Date</div>
                <div class="table-mobile__item-value">{{ item.date }}</div>
              </b-col>
              <b-col cols="6" class="table-mobile__item-right">
                <div class="table-mobile__item-label">Type</div>
                <div class="table-mobile__item-value">{{ item.type }}</div>
              </b-col>
            </b-row>
            <hr>
            <b-row class="table-mobile__item">
              <b-col cols="12" class="table-mobile__item-label">Your Numbers</b-col>
              <b-col cols="12" class="table-mobile__item-value item-numbers">
                <div class="table-mobile__item-value__numbers"
                    v-for="(numbers, index) in item.mainNumbers"
                    :key="index"
                >
                  <span v-for="(n, idx) in numbers" :key="idx" class="ball">{{n}}</span>
                </div>
              </b-col>
            </b-row>
            <hr>
            <b-row class="table-mobile__item table-mobile__2-items">
              <b-col cols="6" class="table-mobile__item-left">
                <div class="table-mobile__item-label">Winnings</div>
                <div class="table-mobile__item-value">{{ item.winnings }}</div>
              </b-col>
              <b-col cols="6" class="table-mobile__item-right">
                <div class="table-mobile__item-label">Amount</div>
                <div class="table-mobile__item-value">{{ item.wager }}</div>
              </b-col>
            </b-row>
            <hr>
            <div class="table-mobile__item table-mobile__submit-mobile">
              <button
                  @click="handleActions('handleReplayQrCodeTicket', item.code, item)"
              >
                QR CODE
              </button>
            </div>
          </div>
        </b-container>
        <b-container v-if="title === 'QR Codes Created'" class="table-mobile__items">
          <div
              v-for="(item, index) in items"
              :key="index"
              class="table-mobile__content"
          >
            <b-row class="table-mobile__item">
              <b-col cols="6" class="table-mobile__item-label">QR Code ID</b-col>
              <b-col cols="6" class="table-mobile__item-value">{{ item.code }}</b-col>
            </b-row>
            <hr>
            <b-row class="table-mobile__item table-mobile__2-items">
              <b-col cols="6" class="table-mobile__item-left">
                <div class="table-mobile__item-label">Date</div>
                <div class="table-mobile__item-value">{{ item.created_at_short }}</div>
              </b-col>
              <b-col cols="6" class="table-mobile__item-right">
                <div class="table-mobile__item-label">Tickets</div>
                <div class="table-mobile__item-value">{{ item.bets.bet.length }}</div>
              </b-col>
            </b-row>
            <hr>
            <div class="table-mobile__item table-mobile__submit-mobile">
              <button
                  @click="handleActions('handleResendQrCode', item.code, item)"
              >
                QR CODE
              </button>
            </div>
          </div>
        </b-container>
        <b-container v-if="title === 'Notifications'" class="table-mobile__items">
          <div
              v-for="(item, index) in items"
              :key="index"
              class="table-mobile__content"
          >
            <b-row class="table-mobile__item table-mobile__2-items">
              <b-col cols="6" class="table-mobile__item-left">
                <div class="table-mobile__item-label">ID</div>
                <div class="table-mobile__item-value">{{ item.id }}</div>
              </b-col>
              <b-col cols="6" class="table-mobile__item-right">
                <div class="table-mobile__item-label">Date</div>
                <div class="table-mobile__item-value">{{ item.created_at_short }}</div>
              </b-col>
            </b-row>
            <hr>
            <b-row class="table-mobile__item">
              <b-col cols="6" class="table-mobile__item-label">Message</b-col>
              <b-col cols="6" class="table-mobile__item-value">{{ item.message }}</b-col>
            </b-row>
          </div>
        </b-container>
      </div>
    </div>
    <div v-if="isPagination" class="table-pagination">
        <div
          v-if="currentPage > 1"
          @click="$emit('changePage', currentPage - 1)"
          class="table-pagination__item active"
        >
          BACK
        </div>
        <div
            v-if="currentPage <= 1"
            class="table-pagination__item"
        >
          BACK
        </div>
        <div class="table-pagination__content">Page {{ currentPage }} of {{ Math.ceil(totalRows/perPage) }}</div>
      <div
          v-if="currentPage >= Math.ceil(totalRows/perPage)"
          class="table-pagination__item"
      >
        NEXT
      </div>
        <div
            v-if="currentPage < Math.ceil(totalRows/perPage)"
            @click="$emit('changePage', currentPage + 1)"
            class="table-pagination__item active"
        >
          NEXT
        </div>
    </div>
<!--    <b-pagination-->
<!--        v-if="isPagination"-->
<!--        v-model="currentPage"-->
<!--        :total-rows="totalRows"-->
<!--        :per-page="perPage"-->
<!--        first-number-->
<!--        last-number-->
<!--        :prev-text="'BACK'"-->
<!--        :prev-class="'pre-class'"-->
<!--        :next-text="'NEXT'"-->
<!--        :ellipsis-class="'item-class'"-->
<!--        :pills="true"-->
<!--        :next-class="'next-class'"-->
<!--        aria-controls="id-table"-->
<!--        @input="$emit('changePage', currentPage)"-->
<!--    />-->
    <QrCodeModal
            :code="qrCode"
    />
  </div>
</template>
<script>
  import accountService from '@/services/account.service';
  import QrCodeModal from "@/components/common/modal/qr-code-modal";
export default {
  props: {
    isPosDevice: {
      type: Boolean,
      default: false
    },
    isPagination: {
      type: Boolean,
      default: true
    },
    customClassContainer: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    customTitle: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    footFields: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      default: () => []
    },
    currentPage: {
      type: Number,
      default: 0
    },
    totalRows: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 0
    },
    customFoot: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      qrCode: ''
    }
  },
  components:{
    QrCodeModal
    // QrcodeVue
  },
  methods: {
    isMobile() {
      return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    // isTablet() {
    //   // return true;
    //   // console.log("table ??" ,  /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(navigator.userAgent));
    //   return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(navigator.userAgent);
    // },
    handleActions(action, valueField, item) {
      const input = item[valueField];
      if (action === 'handleReplayQrCodeTicket') {
        this.handleReplayQrCodeTicket(input);
      }

      if (action === 'handleResendQrCode') {
        this.qrCode = input;
        this.$bvModal.show('modal-center');
      }
    },

    handleReplayQrCodeTicket(id) {
      accountService.replyTransaction(id).then((res) => {
          if (res.status === 'success') {
            this.qrCode = res.data.qr.code;
            this.$bvModal.show('modal-center');
          } else {
            const message = res.message;
            this.$bvToast.toast(message, {
              title: 'Failed',
              variant: 'danger',
              solid: true,
              autoHideDelay: 5000
            })
          }
        },
        () => this.$bvToast.toast('Reply QR code Ticket failed! Please try again', {
          title: 'Failed',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000
        }));
    }
  }
}
</script>
<style scoped lang="scss" src="@/assets/scss/common/table/_table.scss"/>
